import { Order } from "@/data/interfaces/Order";
import api from "./api";

export interface OrderRegistrationPrefill {
  full_name: string;
  email: string;
  phone: string;
  city: string;
}

interface CreateCouponOrderParams {
  amount_eur: number;
  email: string;
  phone: string;
  full_name: string;
  notes?: string;
  product_name?: string;
}

const getOrder = async (orderId: string) => {
  const resp = await api.get(`/orders/${orderId}`);
  return resp.data as Order;
};

const getOrderRegistrationPrefill = async (orderId: string) => {
  const resp = await api.get<{ data: OrderRegistrationPrefill }>(
    `/orders/${orderId}/registration-data`,
  );
  return resp.data.data;
};

const nextRegistrationStep = async (orderItemId: number) => {
  const { data } = await api.put(`/registration-steps/${orderItemId}`);
  return data;
};

const createCouponOrder = async (params: CreateCouponOrderParams) => {
  const response = await api.post("/orders/gift", params);
  return response.data;
};

export default {
  getOrder,
  getOrderRegistrationPrefill,
  nextRegistrationStep,
  createCouponOrder,
};
